import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import * as api from './api'
import type { StageRequirement, StageRequirementRequest } from './types'

export const ANNEX_TRANSITION = 'DRAFT->PUBLISHED'

export const annexGatingKeys = {
  requirements: (configurationCode: string) =>
    ['gating', 'requirements', 'annex', configurationCode, ANNEX_TRANSITION] as const,
}

export function useAnnexRequirements(configurationCode: string) {
  return useQuery<StageRequirement[]>({
    queryKey: annexGatingKeys.requirements(configurationCode),
    queryFn: () => api.listRequirementsByConfiguration(configurationCode, {
      objectType: 'annex', transition: ANNEX_TRANSITION,
    }),
    enabled: !!configurationCode,
  })
}

export function useCreateAnnexRequirement(configurationCode: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (payload: Omit<StageRequirementRequest, 'objectType' | 'transition' | 'stageCode'>) =>
      api.createRequirement(configurationCode, {
        ...payload,
        objectType: 'annex',
        transition: ANNEX_TRANSITION,
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['gating', 'requirements'] })
      qc.invalidateQueries({ queryKey: ['gating', 'gate'] })
    },
  })
}
